import styled from 'styled-components';
import AppCSS from '../../utils/styled';
import { UIView } from '../../utils/styled/styled';
import { SMALLER_BUTTON_WIDTH } from '../../utils/styled/dimensions';

export const Components = {
  Container: styled(UIView)`
    height: 100%;
    overflow-y: auto;
    width: 100%;
  `,
  BodyContainer: styled(UIView)`
    height: 100%;
    overflow-y: auto;
    flex-direction: column;
  `,
  LeftContainer: styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 16px;
    align-items: center;
    padding: 12px 24px;
    width: 100%;
    max-width: 366px;
    background-color: ${AppCSS.colors.white};
  `,
  ProjectCalendarWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    gap: 12px;
  `,
  Separator: styled.div`
    width: 1px;
    height: 16px;
    background-color: ${AppCSS.colors.greys.light};
  `,
  IconButton: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  `,
  TodayButton: styled.div`
    width: ${SMALLER_BUTTON_WIDTH}px;
    min-width: ${SMALLER_BUTTON_WIDTH}px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${AppCSS.colors.white};
    padding: 6px 12px;
    ${AppCSS.radiuses.small};
    border: 1px solid ${AppCSS.colors.greys.medium};
    ${AppCSS.fonts.label12Bold};
    color: ${AppCSS.colors.black};
    cursor: pointer;
  `,
};
